import {
    actionCreator,
    API_URL,
    checkHttpStatus,
    createRequestActionTypes,
    createSearchUrl,
    jsonApiHeader,
    showSuccessMessage,
    createSearchUrlForCustomAPI
} from '../../../actions/utilAction';

export {
    jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    showSuccessMessage,
    createSearchUrlForCustomAPI,
    API_URL,
};
export const AUDIT_LOG = `${API_URL}/api/AuditLog/GetAuditLogsList`;
export const LOGIN_LOG = `${API_URL}/api/AuditLog/GetLoginLogsList`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const LogActionTypes = {
    get_audit_log: createRequestActionTypes('GET_AUDIT_LOG'),
    get_login_log: createRequestActionTypes('GET_LOGIN_LOG'),
    get_masterdata: createRequestActionTypes('GET_MASTERSDATA'),
};


// WEBPACK FOOTER //
// ./src/modules/Logs/constants/ApiConstants.js